import { useState, useImperativeHandle, FC } from 'react';
import BaseModal from '@/components/BaseModal';
import './index.scss';

interface propsType {
  cRef?: any;
  closeRemined?: () => void;
}
const SignInClose: FC<propsType> = (props) => {
  const { cRef } = props;
  const [show, setShow] = useState<boolean>(false); //是否展示
  /**
   * @description: 开启
   */
  const open = () => {
    setShow(true);
  };
  /**
   * @description: 关闭
   */
  const close = () => {
    setShow(false);
  };
  // 绑定ref
  useImperativeHandle(cRef, () => ({
    close,
    open,
  }));
  return (
    <BaseModal show={show}>
      <img src={require('@/images/load.gif')} alt="" className="loading-img" />
    </BaseModal>
  );
};

export default SignInClose;
